
export const SkeletonTemplate = () => (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 animate-pulse">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
        {/* Skeleton Image Gallery */}
        <div className="bg-gray-200 h-[600px] rounded-2xl" />
  
        {/* Skeleton Content */}
        <div className="space-y-12 lg:h-[calc(100vh-4rem)] scrollbar-hidden lg:overflow-y-auto lg:pb-16">
          {/* CTA Skeleton */}
          <div className="space-y-4">
            <div className="h-12 bg-gray-200 rounded-lg w-1/2" />
            <div className="flex gap-4">
              <div className="h-14 bg-gray-200 rounded-lg w-1/2" />
              <div className="h-14 bg-gray-200 rounded-lg w-1/2" />
            </div>
          </div>
  
          {/* License Selector Skeleton */}
          <div className="space-y-4">
            <div className="h-6 bg-gray-200 rounded w-1/4" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[1, 2].map((i) => (
                <div key={i} className="h-32 bg-gray-200 rounded-xl" />
              ))}
            </div>
          </div>
  
          {/* Service Selector Skeleton */}
          <div className="space-y-4">
            <div className="h-6 bg-gray-200 rounded w-1/4" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[1, 2].map((i) => (
                <div key={i} className="h-24 bg-gray-200 rounded-xl" />
              ))}
            </div>
          </div>
  
          {/* Product Details Skeleton */}
          <div className="space-y-4">
            <div className="h-6 bg-gray-200 rounded w-1/3" />
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-4/5" />
            <div className="h-4 bg-gray-200 rounded w-3/4" />
          </div>
  
          {/* Features Grid Skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 bg-gray-100 p-8 rounded-2xl">
            {[1, 2, 3].map((i) => (
              <div key={i} className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-3/4" />
                <div className="h-4 bg-gray-200 rounded w-full" />
                <div className="h-4 bg-gray-200 rounded w-5/6" />
              </div>
            ))}
          </div>
  
          {/* Technology List Skeleton */}
          <div className="space-y-4">
            <div className="h-6 bg-gray-200 rounded w-1/4" />
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-12 bg-gray-200 rounded-lg" />
            ))}
          </div>
  
          {/* Security Badge Skeleton */}
          <div className="h-16 bg-gray-200 rounded-2xl" />
        </div>
      </div>
    </div>
  );